import { ReactElement } from 'react';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { MeetingModuleCard } from '../meeting-card/meeting-card';
import { useInfiniteScroll } from '@components/common';
import { GetMeetings } from '../getMeetings/get-meetings';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { useMeetingFilterStore } from '@store/meetingFilterStore';
import { useMeetingListRBDM } from '@services/hooks/meetings/useMeetingListRBDM';
import { useUserRoleType } from '@hooks/useUserRoleType';
import { useRbdmMeetCompare } from '@services/hooks/meetings/useMeetCompare';
import { useRbdmMeetCompareStore } from '@store/rbdmMeetCompareStore';

export const AllMeetingList = (): ReactElement => {
	const { isFetching: queryFetch, error } = useMeetingListRBDM();
	const { allMeetingFilter } = useMeetingFilterStore();
	const { fetchMore, isFetching, result } = GetMeetings(allMeetingFilter);
	const isRBDM = useUserRoleType();
	const isRBDMMeetCompare = isRBDM === 'RBDM';

	const selectedMdicode =
		allMeetingFilter.mdicode && allMeetingFilter.mdicode.trim() !== '' ? allMeetingFilter.mdicode : undefined;
	useRbdmMeetCompare(isRBDMMeetCompare, selectedMdicode);

	const { meetCompareData } = useRbdmMeetCompareStore();
	useInfiniteScroll(fetchMore);

	return (
		<Wrapper isLoaderVisible={queryFetch || (isFetching && result.length === 0)} isError={error}>
			<>
				<div>
					{isRBDMMeetCompare && (
						<div className="rbdm-meet-compare-wrapper">
							<p>
								FCC Meets Planned: <b>{meetCompareData?.Scheduled_Meeting ?? 0}</b>{' '}
							</p>
							<p>
								Completed: <b>{meetCompareData?.['Completed Meeting'] ?? 0} </b>{' '}
							</p>
						</div>
					)}
				</div>
				<ul className="meeting-card-wrapper row">
					{result.length > 0 ? (
						result.map((meeting) => {
							const meetingData = meeting._data;
							return <MeetingModuleCard key={meetingData.id} data={meetingData} />;
						})
					) : (
						<NoDataFound />
					)}
				</ul>
			</>
		</Wrapper>
	);
};
